// extracted by mini-css-extract-plugin
export default {"root":"Gallery_root__-32sv","galleryImage":"Gallery_galleryImage__gL2i-","galleryList":"Gallery_galleryList__rClL7","galleryListTitle":"Gallery_galleryListTitle__70QYA"};